.profileLabel {
  color: var(--mantine-color-gray-5);
  font-weight: 500;
  font-size: var(--mantine-font-size-sm);

  &[data-active] {
    color: var(--mantine-color-gray-10);
    font-weight: 600;
  }
}

.profileSegment {
  color: var(--mantine-color-gray-5);
  font-weight: 500;
  font-size: var(--mantine-font-size-sm);
  background: transparent;
  cursor: pointer;
}

.profileSegmentActive {
  color: var(--mantine-color-gray-10);
  font-weight: 600;
  font-size: var(--mantine-font-size-sm);
  background-color: var(--mantine-color-gray-0);
  cursor: pointer;
}
